import { create } from 'zustand';

type FavoritesStore = {
  removedDocumentId: string;
  removedLanguageId: string;
  setRemovedDocumentId: (removedDocumentId: string) => void;
  setRemovedLanguageId: (removedLanguageId: string) => void;
  addedDocumentId: string;
  addedLanguageId: string;
  setAddedDocumentId: (addedDocumentId: string) => void;
  setAddedLanguageId: (addedLanguageId: string) => void;
  reset: () => void;
};

export const useFavoritesStore = create<FavoritesStore>((set, get) => ({
  removedDocumentId:'',
  removedLanguageId:'',
  addedDocumentId:'',
  addedLanguageId:'',


  setRemovedDocumentId: (removedDocumentId: string) => set({ removedDocumentId }),
  setRemovedLanguageId: (removedLanguageId: string) => set({ removedLanguageId }),
  setAddedDocumentId: (addedDocumentId: string) => set({ addedDocumentId }),
  setAddedLanguageId: (addedLanguageId: string) => set({ addedLanguageId }),
  reset: () => set({ removedDocumentId: '', removedLanguageId: '', addedDocumentId: '', addedLanguageId: ''}),

  
}));